import { useLocation, useNavigate, useParams, Location, Params, NavigateFunction } from "react-router";

export interface WithRouterProps {
  navigate: NavigateFunction;
  location: Location;
  params: Params;
}

export function withRouter<T>(Component: React.ComponentType<T & WithRouterProps>) {
  const displayName = Component.displayName || Component.name || "Component";
  Component.displayName = `withRouter(${displayName})`;
  return (props) => <Component {...props} location={useLocation()} navigate={useNavigate()} params={useParams()} />;
}
